import React from 'react';
import propTypes from 'prop-types';

import ActionableComponentsList from 'app/ActionableComponentsList/components/ActionableComponentsList';
import { noop } from 'lib/noop';
import { disabledComponents } from 'utils/factory';

/**
 * This component is a redux connected component.
 * This component shows the list of components which are recently created by the user
 * @returns {React.Component} Canvas Menu component
 */
const MostRecentComponents = ({
  components,
  getComponentActions,
  itemActions,
  isContainer,
  isPage,
  onActionSelect,
  isRecentComponentSection,
  onItemClick
}) => {
  return (
    <ActionableComponentsList
      components={disabledComponents(components, isPage, isContainer, false)}
      getItemActions={getComponentActions}
      headerText="Recently Created Components"
      itemActions={itemActions}
      isRecentComponentSection={isRecentComponentSection}
      onActionSelect={onActionSelect}
      onItemClick={onItemClick}
    />
  );
};

MostRecentComponents.propTypes = {
  components: propTypes.arrayOf(propTypes.shape()),
  getComponentActions: propTypes.func,
  isContainer: propTypes.bool,
  isPage: propTypes.bool,
  isRecentComponentSection: propTypes.bool,
  itemActions: propTypes.arrayOf(
    propTypes.shape({
      text: propTypes.string.isRequired,
      action: propTypes.string.isRequired
    })
  ),
  onActionSelect: propTypes.func,
  onItemClick: propTypes.func.isRequired
};

MostRecentComponents.defaultProps = {
  components: [],
  getComponentActions: noop,
  itemActions: undefined,
  isContainer: false,
  isRecentComponentSection: false,
  isPage: false,
  onActionSelect: propTypes.func
};

export default MostRecentComponents;
